import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import type { Dispatch, SetStateAction } from 'react';

export default function DialogMessage({
  openDialog,
  setOpenDialog,
  dialogTitle,
  dialogContentText,
  cancelButtonText,
  handleCancelButton,
  children,
}: {
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
  dialogTitle: string;
  dialogContentText: string;
  cancelButtonText: string;
  handleCancelButton?: () => void;
  children: React.ReactNode;
}) {
  const handleCloseButton = () => {
    handleCancelButton && handleCancelButton();
    setOpenDialog(false);
  };

  return (
    <Dialog onClose={() => setOpenDialog(false)} open={openDialog} sx={{ '.MuiPaper-root': { borderRadius: 3 } }}>
      <Box
        sx={{
          padding: 3,
          textAlign: 'center',
          width: { xs: '100%', md: '520px' },
          maxWidth: { xs: '327px', md: '520px' },
        }}
      >
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <CloseIcon onClick={() => setOpenDialog(false)} sx={{ color: '#757575', cursor: 'pointer' }} />
        </Stack>
        <ErrorIcon
          sx={{
            color: '#00598B',
            backgroundColor: '#EDF4FB',
            padding: 1,
            borderRadius: '50%',
            fontSize: '40px',
          }}
        />
        <DialogTitle
          sx={{
            fontWeight: 500,
            paddingTop: 2,
            paddingBottom: 2,
            px: { xs: 1, md: 3 },
            color: '#212121',
            fontSize: { xs: '16px', md: '24px' },
            lineHeight: { xs: '28px', md: '32px' },
            maxWidth: { md: '30ch' },
            marginInline: 'auto',
          }}
        >
          {dialogTitle}
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', pl: 0, pr: 0, pb: { xs: 3, md: 4 } }}>
          <DialogContentText sx={{ fontSize: { xs: '14px', md: '16px' }, fontWeight: 400 }}>
            {dialogContentText}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            gap: { xs: '8px', md: '16px' },
            p: { xs: 0, md: ' 8px 8px 0 8px' },
          }}
        >
          <Button onClick={handleCloseButton} sx={{ fontSize: '13px', width: '100%', py: 1 }}>
            {cancelButtonText}
          </Button>
          {children}
        </DialogActions>
      </Box>
    </Dialog>
  );
}
